type Props = {
  children: React.ReactNode;
};
const DashboardCard: React.FC<Props> = ({ children }) => (
  <div className="rounded-lg bg-neutrals-gray-light p-5">{children}</div>
);

export default DashboardCard;
